import * as _ from 'lodash';
import type { VoidFunctionComponent } from 'react';

import type { SelectOption } from '../../../../../../../../../types';
import { selectOptionFactory } from '../../../../../../../../../utils';
import FilterCard from '../../../../../../../../generic/Filter/FilterCard';
import type { SetProjectsFilter } from '../../../../types';

export const PROJECT_VISIBILITY_OPTIONS = [
  selectOptionFactory('public', 'Public'),
  selectOptionFactory('private', 'Private'),
];

type Props = {
  setFilters: SetProjectsFilter;
  isPublic?: boolean;
};

// map the optional "isPublic" boolean to an array of selected options
const determineSelectedOptions = (isPublic?: boolean): SelectOption[] => {
  switch (isPublic) {
    case true:
      return [selectOptionFactory('public', 'Public')];
    case false:
      return [selectOptionFactory('private', 'Private')];
    default:
      return [];
  }
};

const ProjectVisibilityFilter: VoidFunctionComponent<Props> = ({ setFilters, isPublic }) => {
  const handleVisibilityChange = (selected: typeof PROJECT_VISIBILITY_OPTIONS) => {
    //  We only want to know about the most recently selected option.
    //  We can be sure that they are ordered based on the update function in FilterCardCheckboxes.
    const selection = _.last(selected);
    const isPublicSelection = selection
      ? //  If there is a selection, we return a boolean based on if the selection is 'public'.
      selection.value === 'public'
      : //  Otherwise, we return undefined.
      undefined;
    // Prefer, since `prevFilters` is always up-to-date
    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        isPublic: isPublicSelection,
      };
    });
  };

  return (
    <FilterCard.Checkboxes
      label="Visibility"
      options={PROJECT_VISIBILITY_OPTIONS}
      values={determineSelectedOptions(isPublic)}
      onChange={handleVisibilityChange}
    />
  );
};

export default ProjectVisibilityFilter;
